import { START_HOMEWORK, SELECT_EXERCISE, SHOW_EXERCISE_CORRECTION, CORRECT_ALL_EXERCISES } from '../actions/status';

const trackedEvents = [START_HOMEWORK, SELECT_EXERCISE, SHOW_EXERCISE_CORRECTION, CORRECT_ALL_EXERCISES];

const verbs = {
    [START_HOMEWORK]: `started`,
    [SELECT_EXERCISE]: `selected`,
    [SHOW_EXERCISE_CORRECTION]: `responded`,
    [CORRECT_ALL_EXERCISES]: `completed`,
};

const analyticsMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    const state = store.getState();

    if (window.dataLayer && trackedEvents.includes(action.type)) {
        const payload = {
            event: 'customEvent',
            eventAction: state.homework.bookTitle ? state.homework.bookTitle : state.homework.publicTitle,
            eventCategory: `${state.application.source && state.application.source.toUpperCase()} - Esercizio`,
            eventLabel: verbs[action.type],
        };

        window.dataLayer.push(payload);

        if (action.type === START_HOMEWORK) {
            window.dataLayer.push({
                ...payload,
                eventLabel: verbs[SELECT_EXERCISE],
            });
        }
    }

    return result;
};

export default analyticsMiddleware;
